import BaseCommand from "@/models/api/commands/BaseCommand";

export class RemoveComponentFileCommand extends BaseCommand {
  CommandName = "RemoveComponentFile";
  Command: { TmpId: string };
  constructor(sessionId: string, operationId: string, tmpId: string) {
    super(sessionId, operationId);
    this.Command = { TmpId: tmpId };
  }
}
